import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Theme } from 'src/app/core/models/Theme.enum';
import { ThemeSwitchService } from 'src/app/core/services/theme/theme-switch.service';
@Component({
  selector: 'app-note-popup',
  templateUrl: './note-popup.component.html',
  styleUrls: ['./note-popup.component.scss']
})
export class NotePopupComponent {

  constructor(public modalRef: BsModalRef, private themeSwitchService: ThemeSwitchService) { }

  public get closeImage(){
    return this.themeSwitchService.getTheme() === Theme.DARK ? 'close.svg' : 'close-light-theme.svg';
  }
}
